import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './subworkspace.module.css';
import './allPages.css';
import { useParams } from 'react-router-dom';
import {
  AlertColor,
  Tooltip,
  Dialog,
  TableContainer,
  Table,
  TableCell,
  TableRow,
  TableHead,
  TableBody,
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { formatDistanceToNow, parseISO } from 'date-fns';
import FetchData from './ServerCall/FetchData';
import {
  ConvertListOfListToDataConnectionRichTreeViewList,
  isNameAllowed,
} from './CommonFunctions/CommonFunctions';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import RichTreeViewControl from './Controls/RichTreeViewControl';
import DatabaseConnectionDialogComponents from './DataConnection/DatabaseConnectionDialogComponents';
import { fontSize, palette } from '..';
import { NotificationDialog, PopUpSpinner } from './CommonFunctions/DialogComponents';
import RefreshIcon from '@mui/icons-material/Refresh';
import { contentTypes, messages } from './CommonFunctions/aliases';
import { useWorkspace } from '../hooks/useWorkspace';
import {
  createWorkspace,
  renameContent,
  updateWorkspace,
  deleteWorkspace as _deleteWorkspace,
  getContentDependencies,
  deleteContent as _deleteContent,
} from '../api/workspace';
import { IWorkspace, TAlert } from '../types/types';
import { downloadFlatFile } from '../api/flatfile';
import Logger from '../Logger';
import { refreshDataset } from '../api';
import { AccessTime } from '@mui/icons-material';
import ScheduleRefresh from './ScheduleDataset/ScheduleRefresh';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowDown';
import datasourceIcon from '../../src/assets/datasource.svg';
import webapiIcon from '../../src/assets/web_api.svg';

const SubWorkspace = () => {
  const [hoveredRowId, setHoveredRowId] = useState<string | null>(null);
  const [workspaceName, setWorkspaceName] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editContentId, setEditContentId] = useState<string | null>(null);
  const [selectedWorkSpaceItem, setSelectedWorkSpaceItem] = useState<IWorkspace | null>(null);
  const [modalType, setModalType] = useState('');
  const { parentId } = useParams();
  const [parentWorkspaceName, setParentWorkspaceName] = useState('');
  const [ownerName, setOwnerName] = useState('');
  const [_loading, setLoading] = useState(false);
  const [alert, setAlert] = useState<null | TAlert>(null);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [mode] = useState('New');
  const [selectedSubworkspaces, setSelectedSubworkspaces] = useState<string[]>([]);
  const [dependencyLoading, setDependencyLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState(''); // State for search input
  const [selectedFilter, setSelectedFilter] = useState('');
  const [showDependencyPopup, setShowDependencyPopup] = useState(false);
  const [dependencyData, setDependencyData] = useState<Array<Object>>([]);
  const [filterOptions, setFilterOptions] = useState({
    'sub-workspace': false,
    playbook: false,
    flatfile: false,
    dataset: false,
    dbconnection: false,
    webapi: false,
  });
  const [tooltipText, setTooltipText] = useState('Filter Contents');
  const [selectedIconSrc, setSelectedIconSrc] = useState('');
  const [isFilterDropdownOpen, setIsFilterDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const [placeholder, setPlaceholder] = useState('Search All');
  const [sortConfig, setSortConfig] = useState({
    key: 'name',
    direction: 'asc',
  }); // state for sorting
  const [dsInfo, setdsInfo] = useState<{
    id: string;
    name: string;
    refreshed: string;
  } | null>(null);
  const [flatFileDropDown, setFlatFileDropDown] = useState('');
  const [dataset, setDataset] = useState<string | null>(null);

  // State for delete confirmation
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [showContentDeleteConfirmation, setShowContentDeleteConfirmation] = useState(false);
  const [selectedContent, setSelectedContent] = useState<IWorkspace | null>(null);

  const [IndexToDelete, setIndexToDelete] = useState<string | null>(null);

  const [severity, setSeverity] = useState<AlertColor>('success');
  const [openAlert, setOpenAlert] = useState<boolean>(false);
  const [testMessage, setTestMessage] = useState<string>('Testing alert');
  // const [subWorkspaces, setSubWorkspaces] = useState<any[] | null>(null);
  // const [error, setError] = useState<any>(null);
  const [errorMessage, setErrorMessage] = useState<any>(null);
  // const [hasFetched, setHasFetched] = useState<boolean>(false);
  const [hideNewIcon, setHideNewIcon] = useState<boolean>(false);
  const [disableNewWorkspace, setDisableNewWorkspace] = useState<boolean>(false);
  const [disableNewFlatfile, setDisableNewFlatfile] = useState<boolean>(false);
  const [disableNewDBConnection, setDisableNewDBConnection] = useState<boolean>(false);
  const [disableNewDataset, setDisableNewDataset] = useState<boolean>(false);
  const [disableNewPlaybook, setDisableNewPlaybook] = useState<boolean>(false);

  const [refreshed, setRefreshed] = useState(false);
  const [scheduledRefresh, setScheduledRefresh] = useState(false);
  const [selectedDataset, setSelectedDataset] = useState<any>(null);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        if (isModalOpen) {
          setIsModalOpen(false);
          setErrorMessage('');
        }
        if (isEditModalOpen) {
          setIsEditModalOpen(false);
          setErrorMessage('');
        }
        if (showDeleteConfirmation) {
          setShowDeleteConfirmation(false);
          setIndexToDelete(null);
        }
        if (showContentDeleteConfirmation) {
          setShowContentDeleteConfirmation(false);
          setSelectedContent(null);
        }
        if (showDependencyPopup) {
          setShowDependencyPopup(false);
          setDependencyData([]);
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [
    isModalOpen,
    isEditModalOpen,
    showDeleteConfirmation,
    showContentDeleteConfirmation,
    showDependencyPopup,
  ]);

  const hideSubworkSpacePageIcons = (workSpace: any) => {
    setHideNewIcon(workSpace?.roleId === 7 || workSpace?.roleId === 0);

    if (workSpace?.roleId === 6) {
      setDisableNewWorkspace(true);
      if (
        workSpace.customPermissions?.find((item: any) => item.contentTypeId === 2)?.privilegeId ===
        1
      ) {
        setDisableNewDBConnection(false);
      } else {
        setDisableNewDBConnection(true);
      }
      if (
        workSpace.customPermissions?.find((item: any) => item.contentTypeId === 3)?.privilegeId ===
        1
      ) {
        setDisableNewDataset(false);
      } else {
        setDisableNewDataset(true);
      }
      if (
        workSpace.customPermissions?.find((item: any) => item.contentTypeId === 4)?.privilegeId ===
        1
      ) {
        setDisableNewFlatfile(false);
      } else {
        setDisableNewFlatfile(true);
      }
      if (
        workSpace.customPermissions?.find((item: any) => item.contentTypeId === 5)?.privilegeId ===
        1
      ) {
        setDisableNewPlaybook(false);
      } else {
        setDisableNewPlaybook(true);
      }
    }
    if (workSpace?.roleId === 5) {
      setDisableNewWorkspace(true);
    }
  };

  // let workSpaces = useSelector(
  //   (state: RootState) => state.permissions.workspaces
  // );
  const { result: workspaceContents, error, loading, refetch } = useWorkspace(parentId, true);

  const handleSubWorkspaceClick = (swid: string, swname: string, parentId: any) => {
    localStorage.setItem('workspace', parentWorkspaceName);
    localStorage.setItem('subworkspace', swname);
    localStorage.setItem('parentWorkspaceId', parentId);
    navigate(`/SubWorkspaceDetails/${swid}`, {
      state: { wname: parentWorkspaceName, childWorkspaceName: swname, parentId: parentId },
    });
  };

  const deleteWorkspace = (index: any, name: any) => {
    setIndexToDelete(index);
    setWorkspaceName(name);
    setShowDeleteConfirmation(true);
  };

  const deleteContent = async (item: any) => {
    if (item.contentType === 5) {
      setIndexToDelete(item.id);
      setShowContentDeleteConfirmation(true);
      setSelectedContent(item);
    } else {
      try {
        setDependencyLoading(true);
        const getDependencies = await getContentDependencies(
          item.id,
          item.contentType,
          item.parentWorkspaceId,
        );
        setDependencyLoading(false);
        if (getDependencies.error) {
          setOpenAlert(true);
          setTestMessage('Unable to get dependency');
          setSeverity('error');
          return;
        }
        if (!getDependencies.hasDependency) {
          setIndexToDelete(item.id);
          setShowContentDeleteConfirmation(true);
          setSelectedContent(item);
        } else {
          const treeViewDependency = ConvertListOfListToDataConnectionRichTreeViewList(
            getDependencies.dependencies,
            [2, 4].includes(item.contentType) ? 'dataset' : 'playbook',
          );
          setDependencyData(treeViewDependency);
          setSelectedContent(item);
          setShowDependencyPopup(true);
        }
      } catch (err) {
        setDependencyLoading(false);
      }
    }
  };
  const handleDeleteContent = async () => {
    if (!parentId || !selectedContent) return;
    setIsLoading(true);
    try {
      const response = await _deleteContent(
        selectedContent.id,
        parentId,
        selectedContent.contentType,
      );

      if (!response.isError) {
        refetch();
      } else {
        console.error(
          `Failed to delete ${getContentTypeLabel(selectedContent.contentType, selectedContent.isExtract, (selectedContent as any).resourceType)?.toUpperCase()}:`,
          response.message || 'Unknown error',
        );
      }
    } catch (error) {
      console.error(
        `Error deleting ${getContentTypeLabel(selectedContent.contentType, selectedContent.isExtract, (selectedContent as any).resourceType)?.toUpperCase()}:`,
        error,
      );
    } finally {
      setIsLoading(false);
      setShowContentDeleteConfirmation(false);
      setIndexToDelete(null);
    }
  };

  const handleDeleteWorkspace = async () => {
    if (!IndexToDelete) return;
    setIsLoading(true);
    try {
      const res = await _deleteWorkspace(IndexToDelete, true);
      if (res.isError) {
        setOpenAlert(true);
        setTestMessage("Workspace can't be deleted before deleting all of its contents first.");
        setSeverity('error');
        return;
      }
      refetch();
    } catch (error) {
      console.error('Error fetching workspace:', error);
    } finally {
      setIsLoading(false);
      setShowDeleteConfirmation(false);
      setIndexToDelete(null);
    }
  };

  const cancelDelete = () => {
    setShowDeleteConfirmation(false);
    setIndexToDelete(null);
    setShowContentDeleteConfirmation(false);
  };

  const handleEditContent = async () => {
    if (!selectedWorkSpaceItem || !editContentId) return;
    if (workspaceName.length > 40) return;
    const isValidName = isNameAllowed(workspaceName);

    if (!isValidName) {
      setErrorMessage(messages.workspace.wrongName);
      return;
    }

    try {
      setIsLoading(true);

      if (selectedWorkSpaceItem.contentType === contentTypes.Workspace) {
        const response = await updateWorkspace(editContentId, workspaceName, parentId);
        if (response.isError) {
          setErrorMessage(response.message);
          return;
        } else {
          refetch();
          setIsEditModalOpen(false);
          setWorkspaceName('');
          setEditContentId(null);
        }
      } else {
        const response = await renameContent(
          selectedWorkSpaceItem.id,
          workspaceName,
          selectedWorkSpaceItem.parentWorkspaceId,
          selectedWorkSpaceItem.contentType,
        );
        if (response.isError) {
          setErrorMessage(response.message);
          return;
        } else {
          refetch();
          setIsEditModalOpen(false);
          setWorkspaceName('');
          setEditContentId(null);
        }
      }
    } catch (error) {
      console.error('Error updating workspace:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const openEditModal = (
    id: string,
    currentName: string,
    currentParentId: string,
    workspaceInfo: IWorkspace,
  ) => {
    setEditContentId(id);
    setWorkspaceName(currentName);
    // setParentId(currentParentId);
    setIsEditModalOpen(true);
    setSelectedWorkSpaceItem(workspaceInfo);
  };

  useEffect(() => {
    const fetchParentWorkspaceName = async () => {
      if (parentId) {
        setIsLoading(true);
        try {
          const response = await FetchData({
            requestType: 'noData',
            method: 'GET',
            url: 'workspace',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            },
          });

          if (response.status) {
            const foundWorkspace = response.data.find(
              (workspace: any) => workspace.id === parentId,
            );

            hideSubworkSpacePageIcons(foundWorkspace);
            if (foundWorkspace) {
              setParentWorkspaceName(foundWorkspace.name);
              setOwnerName(foundWorkspace.createdBy);
            } else {
              console.error('Workspace not found');
            }
          } else {
            console.error('Failed to fetch workspace list:', response.error || 'Unknown error');
          }
        } catch (error) {
          console.error('Error fetching workspace list:', error);
        } finally {
          setIsLoading(false);
        }
      }
    };

    //setTimeout(fetchParentWorkspaceName, 1000);
    fetchParentWorkspaceName();
  }, [parentId]);

  const isWebApi = (contentType: any, resourceType?: string) => {
    return contentType === 2 && resourceType === 'webapi';
  };

  const isCreateContentDisabled = (contentName: string) => {
    if (contentName === 'Workspace') {
      return disableNewWorkspace;
    } else if (contentName === 'Flatfile') {
      return disableNewFlatfile;
    } else if (contentName === 'DB Connection' || contentName === 'Web API') {
      return disableNewDBConnection;
    } else if (contentName === 'Dataset') {
      return disableNewDataset;
    } else if (contentName === 'Playbook') {
      return disableNewPlaybook;
    }
  };

  const handleCreateWorkspace = async () => {
    if (workspaceName.length > 40) {
      setErrorMessage('Workspace name cannot exceed 40 characters.');
      return;
    }
    const isValidName = isNameAllowed(workspaceName);

    if (!isValidName) {
      setErrorMessage(messages.workspace.wrongName);
      return;
    }

    try {
      setIsLoading(true);
      const response = await createWorkspace(workspaceName, parentId);

      if (!response.isError) {
        refetch();
        setWorkspaceName('');
        setIsModalOpen(false);
        setErrorMessage('');
      } else {
        setErrorMessage(response.message);
        console.error(`Failed to create ${modalType}:`, response.message || 'Unknown error');
      }
    } catch (error) {
      console.error(`Error creating ${modalType}:`, error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleWorkspaceSelection = (id: string) => {
    if (selectedSubworkspaces.includes(id)) {
      // If already selected, remove it from the list
      setSelectedSubworkspaces(selectedSubworkspaces.filter((workspaceId) => workspaceId !== id));
    } else {
      // Otherwise, add it to the list
      setSelectedSubworkspaces([...selectedSubworkspaces, id]);
    }
  };

  // Select All function
  // const selectAllWorkspaces = () => {
  //   if (subWorkspaces) {
  //     const allWorkspaceIds = subWorkspaces.map((workspace: any) => workspace.id);
  //     setSelectedSubworkspaces(allWorkspaceIds);
  //   }
  // };

  const getImageSrc = (contentType: any, resourceType?: string) => {
    if (isWebApi(contentType, resourceType)) return webapiIcon;

    switch (contentType) {
      case 1:
        // return "/subworkspace.png";
        // return "/workspace_green.png"
        return '/folder_work.svg';
      case 2:
        return '/database_icon.svg';
      case 3:
        return '/ds.svg';
      case 4:
        return '/flat_file_icon.svg';
      case 5:
        return '/playbook_icon.svg';
      case 7:
        return datasourceIcon;
      default:
        return ''; // Return a default image or an empty string if no match
    }
  };
  const handleClick = async (option: 'refresh' | 'info' | 'scheduledRefresh', id: string) => {
    if (option === 'scheduledRefresh') {
      const info = sortedAndFilteredWorkspaces.find((content) => content.id === id);
      if (!info) return;
      setSelectedDataset({
        workspaceId: parentId,
        datasetId: info.id,
      });
      setScheduledRefresh(true);
      return;
    }
    if (option === 'refresh') {
      setLoading(true);
      const res = await refreshDataset(id, parentId ?? '');
      if (res.isError)
        setAlert({
          severity: 'error',
          message: res.message,
        });
      else setRefreshed(true);
      setLoading(false);
    } else {
      const info = sortedAndFilteredWorkspaces.find((content) => content.id === id);
      if (!info) return;
      setdsInfo({
        id: info.id,
        name: info.name,
        refreshed: info.refreshedAt ?? '',
      });
    }
  };
  const getContentTypeLabel = (contentType: any, isExtract?: boolean, resourceType?: string) => {
    if (isWebApi(contentType, resourceType)) return 'webapi';

    switch (contentType) {
      case 1:
        return 'sub-workspace';
      case 2:
        return 'dbconnection';
      case 3:
        return isExtract ? 'dataset (Extract)' : 'dataset';
      case 4:
        return 'flatfile';
      case 5:
        return 'playbook';
      default:
        return 'unknown';
    }
  };
  const getContentTypeName = (contentType: any, resourceType?: string) => {
    if (isWebApi(contentType, resourceType)) return 'Web API';

    switch (contentType) {
      case 2:
        return 'DB Connection';
      case 3:
        return 'Data Set';
      case 4:
        return 'Flat File';
      case 5:
        return 'Playbook';
      default:
        return 'unknown';
    }
  };

  const navigateToPages = (name: string, isFlatFile: boolean = false) => {
    switch (name) {
      case 'DB Connection':
        navigate(`/newdataconnection/${parentId}`, {
          state: {
            mode: mode,
            workspaceId: parentId,
            workspaceName: parentWorkspaceName,
          },
        });
        break;
      case 'Dataset':
        navigate(`/newdataset/${parentId}`, {
          state: {
            mode: mode,
            parentId: parentId,
            workspaceName: parentWorkspaceName,
            isFlatFile: isFlatFile,
          },
        });
        break;
      case 'Playbook':
        navigate(`/playbook?workspaceId=${parentId}`, {
          state: {
            mode: mode,
            parentId: parentId,
            workspaceName: parentWorkspaceName,
          },
        });
        break;
      case 'Flatfile':
        navigate(`/flatfileupload/${parentId}`, {
          state: {
            mode: mode,
            parentId: parentId,
            workspaceName: parentWorkspaceName,
          },
        });
        break;

      case 'Web API':
        navigate(`/webapidatasource/${parentId}`, {
          state: {
            mode: mode,
            parentId: parentId,
            workspaceName: parentWorkspaceName,
          },
        });
        break;

      default:
        return;
    }
  };

  const navigateToEditPages = (e: IWorkspace) => {
    const item = e as any;

    switch (e.contentType) {
      case 2:
        if (item.resourceType === 'webapi') {
          navigate(`/webapidatasource/${parentId}/${e.id}?workspaceid=${parentId}`, {
            state: {
              mode: 'Edit',
              parentId: parentId,
              workspaceName: parentWorkspaceName,
              id: e.id,
            },
          });
        } else {
          navigate(`/dbconnection/${e.id}?workspaceid=${parentId}`, {
            state: {
              mode: 'Edit',
              parentId: parentId,
              workspaceName: parentWorkspaceName,
              id: e.id,
            },
          });
        }
        break;
      case 3:
        navigate(`/editdataset/${e.id}`, {
          state: {
            mode: 'Edit',
            parentId: parentId,
            workspaceName: parentWorkspaceName,
            dsId: e.id,
          },
        });
        break;
      case 4:
        navigate(`/editflatfile/${parentId}`, {
          state: {
            mode: 'Edit',
            parentId: parentId,
            workspaceName: parentWorkspaceName,
            file: e,
          },
        });
        break;
      case 5:
        navigate(`/playbook?workspaceId=${parentId}&playbookId=${e.id}`, {
          state: {
            mode: 'Edit',
            workspaceName: parentWorkspaceName,
          },
        });
        break;
    }
  };

  useEffect(() => {
    if (workspaceContents) {
      setFilterOptions({
        'sub-workspace': workspaceContents.some((item) => item.contentType === 1),
        dbconnection: workspaceContents.some(
          (item: any) => item.contentType === 2 && !isWebApi(item.contentType, item.resourceType),
        ),
        webapi: workspaceContents.some((item: any) =>
          isWebApi(item.contentType, item.resourceType),
        ),
        dataset: workspaceContents.some((item) => item.contentType === 3),
        flatfile: workspaceContents.some((item) => item.contentType === 4),
        playbook: workspaceContents.some((item) => item.contentType === 5),
      });
    }
  }, [workspaceContents]);

  const filteredWorkspaces = React.useMemo(() => {
    return workspaceContents.filter((workspace) => {
      const matchesSearch = workspace.name.toLowerCase().includes(searchQuery.toLowerCase());
      if (!selectedFilter) return matchesSearch;

      let matchesFilter = false;

      if (selectedFilter === 'webapi') {
        matchesFilter = isWebApi(workspace.contentType, (workspace as any).resourceType);
      } else if (selectedFilter === 'dbconnection') {
        matchesFilter =
          workspace.contentType === 2 &&
          !isWebApi(workspace.contentType, (workspace as any).resourceType);
      } else {
        matchesFilter =
          getContentTypeLabel(workspace.contentType) ===
          selectedFilter; /** do not pass extract as we want to filter all datasets both extract or non extract */
      }

      return matchesSearch && matchesFilter;
    });
  }, [workspaceContents, searchQuery, selectedFilter]);

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value);
  };

  const handleFilterChange = (selectedValue: any) => {
    setSelectedFilter(selectedValue);
    let contentType;
    let resourceType;

    switch (selectedValue) {
      case 'sub-workspace':
        setPlaceholder('Search Workspace');
        setTooltipText('Filtered by Workspaces');
        contentType = 1;
        break;
      case 'dbconnection':
        setPlaceholder('Search Database');
        setTooltipText('Filtered by Databases');
        contentType = 2;
        break;
      case 'webapi':
        setPlaceholder('Search Web APIs');
        setTooltipText('Filtered by Web APIs');
        contentType = 2;
        resourceType = 'webapi';
        break;
      case 'dataset':
        setPlaceholder('Search Dataset');
        setTooltipText('Filtered Datasets');
        contentType = 3;
        break;
      case 'flatfile':
        setPlaceholder('Search Flatfile');
        setTooltipText('Filtered Flatfiles');
        contentType = 4;
        break;
      case 'playbook':
        setPlaceholder('Search Playbook');
        setTooltipText('Filtered Playbooks');
        contentType = 5;
        break;
      default:
        setPlaceholder('Search All');
        setTooltipText('Filter Contents');
        break;
    }
    const iconSrc = getImageSrc(contentType, resourceType);
    setSelectedIconSrc(iconSrc);
    setIsFilterDropdownOpen(false);
  };

  const openAccessModal = (workspaceId: any, workspaceName: string) => {
    // navigate(`/workspace/access/${parentId}`, { state: { workspaceId } });
    navigate(`/workspace/access/${workspaceId}`, {
      state: { parentId, workspaceName },
    });
  };

  const openAccessModalforContent = (workspaceId: any) => {
    navigate(`/content/access/${workspaceId}`, { state: { parentId } });
  };

  const toggleFilterDropdown = () => {
    setIsFilterDropdownOpen(!isFilterDropdownOpen);
  };

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsFilterDropdownOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const sortedAndFilteredWorkspaces = React.useMemo(() => {
    let sortedItems = [...filteredWorkspaces];

    if (sortConfig.key) {
      sortedItems.sort((a, b) => {
        let aValue, bValue;

        if (sortConfig.key === 'name') {
          aValue = a.name ? a.name.toLowerCase() : '';
          bValue = b.name ? b.name.toLowerCase() : '';
        } else if (sortConfig.key === 'type') {
          aValue = getContentTypeLabel(a.contentType, a.isExtract, (a as any).resourceType) || '';
          bValue = getContentTypeLabel(b.contentType, b.isExtract, (b as any).resourceType) || '';
        } else if (sortConfig.key === 'modified' || sortConfig.key === 'createdAt') {
          const aDate = a.updatedAt
            ? parseISO(a.updatedAt)
            : a.createdAt
              ? parseISO(a.createdAt)
              : new Date(0);
          const bDate = b.updatedAt
            ? parseISO(b.updatedAt)
            : b.createdAt
              ? parseISO(b.createdAt)
              : new Date(0);

          aValue = aDate.getTime();
          bValue = bDate.getTime();
        } else {
          return 0;
        }

        if (aValue < bValue) {
          return sortConfig.direction === 'asc' ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }
    return sortedItems;
  }, [filteredWorkspaces, sortConfig]);

  const handleSort = (key: any) => {
    const newDirection = sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc';
    setSortConfig({ key, direction: newDirection });
  };

  const getSortIcon = (key: any) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === 'asc' ? (
        <img className="headerIcon-up" src="/sort-up.png" alt="Ascending" />
      ) : (
        <img className="headerIcon-down" src="/sort-down.png" alt="Descending" />
      );
    }
    return <img className="headerIcon" src="/sort.png" alt="Default" />;
  };

  const openMoreOptions = (id: string, isDataset: boolean) => {
    if (!isDataset) setFlatFileDropDown(id);
    else setDataset(id);
  };
  const closeMoreOptions = (isDataset: boolean) => {
    if (isDataset) setDataset(null);
    else setFlatFileDropDown('');
  };

  const handleDownload = async (flatFileId: string) => {
    try {
      const id = flatFileId.split(' ')[0];
      const fileName = flatFileId.split(' ')[1];
      const result = await downloadFlatFile(id);

      if (!result.isError && result.data) {
        const blob = new Blob([result.data], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');

        link.href = url;
        link.download = `${fileName}.csv`;
        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } else {
        Logger('info', 'Error downloading file:');
        return {
          success: false,
          errorMessage: result.message,
        };
      }
    } catch (error) {
      Logger('error', 'File Download exception', error);
      return {
        success: false,
        errorMessage: 'An unexpected error occurred while downloading file',
      };
    }
  };

  const handleUpdateFlatFile = (flatFileId: string) => {
    const id = flatFileId.split(' ')[0];
    // const fileName = flatFileId.split(' ')[1];

    navigate(`/flatfileupload/${parentId}`, {
      state: {
        mode: 'update',
        parentId: parentId,
        fileId: id,
        workspaceName: parentWorkspaceName,
      },
    });
  };

  if (error)
    return (
      <div className="loading-error-info">
        <p
          className="loading-default-text"
          style={{
            fontSize: fontSize.medium,
            color: palette.primary.contrastText,
          }}
        >
          Error loading sub-workspaces.
        </p>
      </div>
    );

  return (
    <React.Fragment>
      {showDependencyPopup ? (
        <RichTreeViewControl
          isWarning={true}
          list={dependencyData}
          showControls={false}
          showInPopup={true}
          handleCloseButtonClick={(e: any) => {
            setShowDependencyPopup(false);
            setSelectedContent(null);
          }}
          title={[`Can't delete ${selectedContent!.name}.`, 'Here is the list of dependencies.']}
          hasMultipleTitle={true}
        />
      ) : null}
      <div className={`${styles.subworkspaceContainer} subworkspace-container`}>
        <div className="sub-heading" style={{ height: '50px', border: '1px solid transparent' }}>
          <img
            src="/folder_work.svg"
            style={{ width: '24px', height: '24px' }}
            alt="Workspace Icon"
          ></img>
          <div>
            <h3
              style={{
                // marginTop: "-4px",
                // marginBottom: "5px",
                padding: '0px',
                margin: '0px',
                marginLeft: '6px',
                fontSize: fontSize.large,
                color: palette.primary.contrastText,
              }}
            >
              {parentWorkspaceName}
            </h3>
          </div>
        </div>

        <div className="subworkspace-button-add-search-container">
          <div className="subworkspace-action-buttons">
            <div className={styles.dropdown}>
              {!hideNewIcon && !isLoading && (
                <button
                  className={`${styles.createWorkspace} create-workspace`}
                  style={{
                    fontSize: fontSize.medium,
                    color: palette.primary.main,
                  }}
                >
                  <img
                    className="addIcon addIconDefault"
                    src="/add_green.png"
                    alt="Add Users Logo"
                    style={{ width: '16px', height: '16px' }}
                  />
                  &nbsp;New
                </button>
              )}
              <div className={styles.dropdownContent}>
                {[
                  { name: 'Workspace', icon: getImageSrc(1) },
                  { name: 'Data Source', icon: getImageSrc(7) },
                  { name: 'Dataset', icon: getImageSrc(3) },
                  { name: 'Playbook', icon: getImageSrc(5) },
                ].map((item) =>
                  item.name === 'Data Source' ? (
                    <div className={styles.dropdownItem} key={item.name}>
                      <button
                        style={{
                          display: 'flex',
                          fontSize: fontSize.medium,
                          alignItems: 'center',
                          width: '100%',
                          justifyContent: 'space-between',
                          paddingRight: '10px',
                        }}
                        className={
                          isCreateContentDisabled('Flatfile') &&
                          isCreateContentDisabled('DB Connection')
                            ? styles.disabledOption
                            : ''
                        }
                      >
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <img
                            src={item.icon}
                            alt={`${item.name} Icon`}
                            style={{
                              marginRight: '15px',
                              width: '17px',
                              height: '17px',
                            }}
                          />
                          {item.name}
                        </div>
                        <KeyboardArrowRightIcon
                          sx={{ fontSize: 18, color: '#646161', flexShrink: 0 }}
                        />
                      </button>
                      <div className={styles.subDropdownContent}>
                        <button
                          style={{
                            display: 'flex',
                            fontSize: fontSize.medium,
                            alignItems: 'center',
                          }}
                          className={
                            isCreateContentDisabled('Flatfile') ? styles.disabledOption : ''
                          }
                          onClick={() => navigateToPages('Flatfile')}
                        >
                          <img
                            src={getImageSrc(4)}
                            alt="Flat File Icon"
                            style={{
                              marginRight: '15px',
                              width: '17px',
                              height: '17px',
                            }}
                          />
                          Flat File
                        </button>
                        <button
                          style={{
                            display: 'flex',
                            fontSize: fontSize.medium,
                            alignItems: 'center',
                          }}
                          className={
                            isCreateContentDisabled('DB Connection') ? styles.disabledOption : ''
                          }
                          onClick={() => navigateToPages('DB Connection')}
                        >
                          <img
                            src={getImageSrc(2)}
                            alt="DB Connection Icon"
                            style={{
                              marginRight: '15px',
                              width: '17px',
                              height: '17px',
                            }}
                          />
                          DB Connection
                        </button>
                        <button
                          style={{
                            display: 'flex',
                            fontSize: fontSize.medium,
                            alignItems: 'center',
                          }}
                          onClick={() => navigateToPages('Web API')}
                        >
                          <img
                            src={getImageSrc(2, 'webapi')}
                            alt="Web API Icon"
                            style={{
                              marginRight: '15px',
                              width: '17px',
                              height: '17px',
                            }}
                          />
                          Web API
                        </button>
                      </div>
                    </div>
                  ) : (
                    <button
                      key={item.name}
                      style={{
                        display: 'flex',
                        fontSize: fontSize.medium,
                        alignItems: 'center',
                      }}
                      className={isCreateContentDisabled(item.name) ? styles.disabledOption : ''}
                      onClick={() => {
                        setModalType(item.name);
                        if (item.name === 'Workspace') {
                          setIsModalOpen(true);
                          return;
                        }
                        navigateToPages(item.name);
                      }}
                    >
                      <img
                        src={item.icon}
                        alt={`${item.name} Icon`}
                        style={{
                          marginRight: '15px',
                          width: '17px',
                          height: '17px',
                        }}
                      />
                      {item.name}
                    </button>
                  ),
                )}
              </div>
            </div>
          </div>

          <div className="subWorkspaceSelectActionContainer">
            <div className="subWorkspaceActionsContainer"></div>

            <div className={styles.SearchFilterContainer}>
              <div className={styles.filterDropdownContainer}>
                <div
                  className={styles.filterTooltipImgContainer}
                  ref={dropdownRef}
                  onClick={toggleFilterDropdown}
                  onBlur={() => setIsFilterDropdownOpen(false)}
                  onMouseOver={() => setIsFilterDropdownOpen(true)}
                  onMouseLeave={() => setIsFilterDropdownOpen(false)}
                >
                  <Tooltip
                    title={tooltipText}
                    placement="top"
                    slotProps={{
                      tooltip: {
                        sx: {
                          fontSize: '12px',
                        },
                      },
                    }}
                  >
                    {selectedFilter ? (
                      <img
                        src="/filter.png"
                        alt="Filter Icon"
                        style={{ cursor: 'pointer', marginTop: '3px' }}
                      />
                    ) : (
                      <img
                        src="/filter-outline.png"
                        alt="Filter Icon"
                        style={{ cursor: 'pointer', marginTop: '3px' }}
                      />
                    )}
                  </Tooltip>
                  {selectedFilter && selectedIconSrc && (
                    <img
                      src={selectedIconSrc}
                      alt="Selected Filter Icon"
                      style={{
                        marginLeft: '8px',
                        cursor: 'pointer',
                        width: '14px',
                        height: '14px',
                      }}
                      onClick={() => handleFilterChange('')}
                    />
                  )}
                </div>
                {isFilterDropdownOpen && (
                  <div
                    className={styles.filterDropdown}
                    style={{ transform: 'translate(0,0)' }}
                    onMouseOver={() => setIsFilterDropdownOpen(true)}
                    onMouseLeave={() => setIsFilterDropdownOpen(false)}
                  >
                    <ul
                      className={styles.filterDropdownContent}
                      style={{
                        fontSize: fontSize.medium,
                        color: palette.primary.contrastText,
                      }}
                    >
                      <li
                        onClick={() => handleFilterChange('')}
                        style={{
                          paddingTop: '7px',
                          display: 'flex',
                          justifyContent: 'flex-start',
                          alignItems: 'center',
                        }}
                      >
                        <span>&nbsp;&nbsp;&nbsp;&nbsp;</span> All
                      </li>

                      <li
                        onClick={() => handleFilterChange('sub-workspace')}
                        className={!filterOptions['sub-workspace'] ? styles.disabledOption : ''}
                        style={{
                          display: 'flex',
                          justifyContent: 'flex-start',
                          alignItems: 'center',
                        }}
                      >
                        <img src="/folder_work.svg" alt="Workspace"></img>
                        Workspace
                      </li>
                      <li
                        className={styles.dropdownItem}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          paddingRight: '10px',
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            width: '100%',
                            cursor: 'default',
                          }}
                        >
                          <img src={getImageSrc(7)} alt="datasource" />
                          Data Source
                        </div>
                        <KeyboardArrowRightIcon
                          sx={{
                            fontSize: 18,
                            color: '#646161',
                            flexShrink: 0,
                          }}
                        />

                        <div
                          className={styles.subDropdownContent}
                          style={{
                            right: '100%',
                            left: 'auto',
                            marginRight: '2px',
                            paddingTop: '4px',
                            paddingBottom: '4px',
                            fontSize: fontSize.medium,
                          }}
                        >
                          <button
                            onClick={() => handleFilterChange('flatfile')}
                            className={!filterOptions.flatfile ? styles.disabledOption : ''}
                            style={{
                              fontSize: fontSize.medium,
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            <img
                              src="/flat_file_icon.svg"
                              alt="flatfile"
                              style={{ width: '14px', marginRight: '10px' }}
                            />{' '}
                            Flatfile
                          </button>
                          <button
                            onClick={() => handleFilterChange('dbconnection')}
                            className={!filterOptions.dbconnection ? styles.disabledOption : ''}
                            style={{
                              fontSize: fontSize.medium,
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            <img
                              src="/database_icon.svg"
                              alt="database"
                              style={{ width: '14px', marginRight: '10px' }}
                            />{' '}
                            DB Connection
                          </button>
                          <button
                            onClick={() => handleFilterChange('webapi')}
                            className={!filterOptions.webapi ? styles.disabledOption : ''}
                            style={{
                              fontSize: fontSize.medium,
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            <img src={getImageSrc(2, 'webapi')} alt="webapi" /> Web API
                          </button>
                        </div>
                      </li>

                      <li
                        onClick={() => handleFilterChange('dataset')}
                        className={!filterOptions.dataset ? styles.disabledOption : ''}
                        style={{
                          display: 'flex',
                          justifyContent: 'flex-start',
                          alignItems: 'center',
                        }}
                      >
                        {/* <SchemaIcon
                        style={{
                          color: "#616164",
                          width: "14px",
                          height: "15px",
                          marginRight: "10px",
                          transform: "translateY(2px)",
                        }}
                      /> */}
                        <img src="/ds.svg" alt="Dataset"></img>
                        Dataset
                      </li>

                      <li
                        onClick={() => handleFilterChange('playbook')}
                        className={!filterOptions.playbook ? styles.disabledOption : ''}
                        style={{
                          display: 'flex',
                          justifyContent: 'flex-start',
                          alignItems: 'center',
                        }}
                      >
                        <img src="/playbook_icon.svg" alt="playbook"></img>
                        Playbook
                      </li>
                    </ul>
                  </div>
                )}
              </div>

              <div className="subWorkspaceSearchContainer">
                <input
                  type="text"
                  className="subWorkspaceSearchInput"
                  value={searchQuery}
                  onChange={handleSearch}
                  placeholder={placeholder}
                  style={{
                    fontSize: fontSize.medium,
                    color: palette.primary.contrastText,
                  }}
                />

                <img src="/glass.png" alt="Search Icon" className="subWorkspaceSearchIcon" />
              </div>
            </div>
          </div>
        </div>

        {loading ? (
          <div className={styles.subLoadingContainer}>
            <div className="user-spinner"></div>
          </div>
        ) : sortedAndFilteredWorkspaces?.length === 0 && searchQuery.length === 0 ? (
          <div className="no-user-info">
            <p
              className="loading-default-text"
              style={{
                fontSize: fontSize.medium,
                color: palette.primary.contrastText,
              }}
            >
              No contents available.
            </p>
          </div>
        ) : (
          <TableContainer className="subworkspce-table-container">
            <Table className={`${styles.subWorkspaceTable} subWorkspace-table`}>
              <TableHead>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell></TableCell>

                  <TableCell onClick={() => handleSort('name')}>
                    Name <span className="icon-wrapper">{getSortIcon('name')}</span>
                  </TableCell>
                  <TableCell onClick={() => handleSort('type')}>
                    Type <span className="icon-wrapper">{getSortIcon('type')}</span>
                  </TableCell>
                  <TableCell onClick={() => handleSort('modified')}>
                    Modified <span className="icon-wrapper">{getSortIcon('modified')}</span>
                  </TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {sortedAndFilteredWorkspaces.length > 0 ? (
                  sortedAndFilteredWorkspaces.map((workspace, index: any) => (
                    <TableRow
                      key={workspace.id}
                      onMouseEnter={() => setHoveredRowId(workspace.id)}
                      onMouseLeave={() => setHoveredRowId(null)}
                      className={selectedSubworkspaces.includes(workspace.id) ? 'selectedRow' : ''}
                    >
                      <TableCell>
                        {/* // <input
                        //   type="checkbox"
                        //   checked={selectedSubworkspaces.includes(workspace.id)}
                        //   onChange={() =>
                        //     handleWorkspaceSelection(workspace.id)
                        //   }
                        //   style={{ width: "16px", height: "16px" }}
                        // /> */}
                      </TableCell>

                      <TableCell>
                        {/* {workspace.contentType === 3 ? (
                          <SchemaIcon
                            style={{
                              color: "#616164",
                              width: "14px",
                              height: "15px",
                            }}
                          ></SchemaIcon>
                        ) : ( */}
                        <img
                          src={getImageSrc(workspace.contentType, (workspace as any).resourceType)}
                          alt="Content Type Icon"
                          style={{ width: '16px', height: '16px' }}
                        />
                      </TableCell>

                      {workspace.contentType === 1 ? (
                        <TableCell
                          onClick={() =>
                            handleSubWorkspaceClick(workspace.id, workspace.name, parentId)
                          }
                          className={styles.nameHyperlink}
                          data-testId={`${workspace.name}_name`}
                          style={{
                            fontSize: fontSize.medium,
                            color: palette.primary.contrastText,
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            maxWidth: '150px',
                          }}
                        >
                          {workspace.name}
                        </TableCell>
                      ) : (
                        <TableCell
                          data-testId={`${workspace.name}_name`}
                          style={{
                            fontSize: fontSize.medium,
                            color: palette.primary.contrastText,
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            maxWidth: '150px',
                            textDecoration: hoveredRowId === workspace.id ? 'underline' : '',
                            cursor: hoveredRowId === workspace.id ? 'pointer' : '',
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            if (hoveredRowId === workspace.id) {
                              navigateToEditPages(workspace);
                            }
                          }}
                        >
                          {workspace.name}
                        </TableCell>
                      )}

                      <TableCell
                        style={{
                          fontSize: fontSize.medium,
                          color: palette.primary.contrastText,
                        }}
                      >
                        {getContentTypeLabel(
                          workspace.contentType,
                          workspace.isExtract,
                          (workspace as any).resourceType,
                        )}
                      </TableCell>
                      <TableCell
                        style={{
                          fontSize: fontSize.medium,
                          color: palette.primary.contrastText,
                        }}
                      >
                        {workspace.updatedAt || workspace.createdAt
                          ? formatDistanceToNow(
                              parseISO(workspace.updatedAt || workspace.createdAt),
                              { addSuffix: true },
                            )
                          : 'No date available'}
                      </TableCell>
                      {/* Inline css for contional rendering even buttons */}
                      <TableCell sx={{ position: 'relative', paddingRight: '2.5em' }}>
                        {workspace.roleId <= 8 && (
                          <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <div className="subworkspace-img-icon">
                              {workspace.contentType === 4 || workspace.isExtract ? (
                                <button
                                  onMouseEnter={() =>
                                    openMoreOptions(
                                      `${workspace.id} ${workspace.name}`,
                                      workspace.contentType === 3 && !!workspace.isExtract,
                                    )
                                  }
                                  onMouseLeave={() =>
                                    closeMoreOptions(
                                      workspace.contentType === 3 && !!workspace.isExtract,
                                    )
                                  }
                                  data-testId={`${workspace.name}_options`}
                                  style={{
                                    background: 'none',
                                    border: 'none',
                                  }}
                                >
                                  <img
                                    src={
                                      hoveredRowId === workspace.id
                                        ? '/options.png'
                                        : '/options_grey.png'
                                    }
                                    alt="Options"
                                    style={{
                                      marginTop: '5px',
                                      width: '18px',
                                      height: '18px',
                                    }}
                                  />
                                </button>
                              ) : (
                                <div
                                  style={{
                                    width: '30px',
                                    height: '28px',
                                    padding: '1px 6px',
                                  }}
                                  about="placeholder"
                                ></div>
                              )}
                              {flatFileDropDown.split(' ')[0] === workspace.id && (
                                <div
                                  className={styles.flatFileDropDown}
                                  style={{ transform: 'translate(0,0)' }}
                                >
                                  <ul
                                    className={styles.flatFileDropDownContent}
                                    onMouseEnter={() =>
                                      openMoreOptions(`${workspace.id} ${workspace.name}`, false)
                                    }
                                    onMouseLeave={() => closeMoreOptions(false)}
                                    style={{
                                      fontSize: fontSize.extraSmall,
                                      color: palette.primary.contrastText,
                                    }}
                                  >
                                    <li
                                      onClick={() => handleDownload(flatFileDropDown)}
                                      className=""
                                      style={{
                                        color: 'gray',
                                        display: 'flex',
                                        justifyContent: 'flex-start',
                                        alignItems: 'center',
                                      }}
                                    >
                                      <img src="/download.png" alt="download"></img>
                                      Download as CSV
                                    </li>
                                    <li
                                      onClick={() => handleUpdateFlatFile(flatFileDropDown)}
                                      style={{
                                        color: 'gray',
                                        display: 'flex',
                                        justifyContent: 'flex-start',
                                        alignItems: 'center',
                                      }}
                                    >
                                      <img src="/reupload.png" alt="reupload"></img>
                                      Re-upload file
                                    </li>
                                    <li
                                      onClick={() => {
                                        closeMoreOptions(false);
                                        navigate(`/newdataset/${parentId}`, {
                                          state: {
                                            parentId,
                                            workspaceName: workspace.name,
                                            isFlatFile: true,
                                            flatfileId: workspace.id,
                                            openCurrentWorkspace: true,
                                          },
                                        });
                                      }}
                                      className=""
                                      style={{
                                        color: 'gray',
                                        display: 'flex',
                                        justifyContent: 'flex-start',
                                        alignItems: 'center',
                                      }}
                                    >
                                      <img
                                        src="/ds.svg"
                                        alt="dataset"
                                        style={{ filter: 'brightness(0)' }}
                                      />
                                      Create Data Set
                                    </li>
                                  </ul>
                                </div>
                              )}
                              {dataset && dataset?.split(' ')[0] === workspace.id && (
                                <Box
                                  className={styles.flatFileDropDown}
                                  sx={{ transform: 'translate(0,0)', fontSize: '5px !important' }}
                                >
                                  <List
                                    onMouseEnter={() =>
                                      openMoreOptions(`${workspace.id} ${workspace.name}`, true)
                                    }
                                    onMouseLeave={() => closeMoreOptions(true)}
                                  >
                                    <ListItem disablePadding>
                                      <ListItemButton
                                        sx={{
                                          paddingBlock: 0,
                                          gap: '0.5rem',
                                        }}
                                        onClick={() =>
                                          handleClick('scheduledRefresh', workspace.id)
                                        }
                                      >
                                        {/* <ListItemIcon> */}
                                        <AccessTime fontSize="small" />
                                        {/* </ListItemIcon> */}
                                        <ListItemText primary="Schedule Refresh" />
                                      </ListItemButton>
                                    </ListItem>
                                    <ListItem disablePadding>
                                      <ListItemButton
                                        sx={{
                                          paddingBlock: 0,
                                          gap: '0.5rem',
                                        }}
                                        onClick={() => handleClick('refresh', workspace.id)}
                                      >
                                        {/* <ListItemIcon> */}
                                        <RefreshIcon fontSize="small" />
                                        {/* </ListItemIcon> */}
                                        <ListItemText primary="Refresh Now" />
                                      </ListItemButton>
                                    </ListItem>
                                    <ListItem disablePadding>
                                      <ListItemButton
                                        onClick={() => handleClick('info', workspace.id)}
                                        sx={{
                                          paddingBlock: 0,
                                          gap: '0.5rem',
                                        }}
                                      >
                                        {/* <ListItemIcon> */}
                                        <InfoOutlineIcon fontSize="small" />
                                        {/* </ListItemIcon> */}
                                        <ListItemText primary="Refresh Info" />
                                      </ListItemButton>
                                    </ListItem>
                                  </List>
                                </Box>
                              )}
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();

                                  if (workspace.contentType === 1) {
                                    handleSubWorkspaceClick(workspace.id, workspace.name, parentId);
                                  } else {
                                    navigateToEditPages(workspace);
                                  }
                                }}
                                data-testId={`${workspace.name}_view_edit`}
                                style={{
                                  background: 'none',
                                  border: 'none',
                                }}
                              >
                                <Tooltip
                                  title="View / Edit"
                                  slotProps={{
                                    tooltip: {
                                      sx: {
                                        fontSize: '12px',
                                      },
                                    },
                                  }}
                                >
                                  <img
                                    src={
                                      hoveredRowId === workspace.id
                                        ? '/eye_purple.png'
                                        : '/eye_grey.png'
                                    }
                                    alt="Change"
                                    style={{
                                      marginTop: '5px',
                                      width: '20px',
                                      height: '20px',
                                    }}
                                  />
                                </Tooltip>
                              </button>

                              {(workspace.contentType === 1 &&
                                workspace.roleId < 5 &&
                                workspace.roleId > 0) ||
                              (workspace.levelId && workspace.levelId < 3) ||
                              workspace.roleId === 8 ? (
                                <>
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      openEditModal(
                                        workspace.id,
                                        workspace.name,
                                        workspace.parentWorkspaceId,
                                        workspace,
                                      );
                                    }}
                                    data-testId={`${workspace.name}_rename`}
                                    style={{
                                      background: 'none',
                                      border: 'none',
                                    }}
                                  >
                                    <Tooltip
                                      title="Rename"
                                      slotProps={{
                                        tooltip: {
                                          sx: {
                                            fontSize: '12px',
                                          },
                                        },
                                      }}
                                    >
                                      <img
                                        src={
                                          hoveredRowId === workspace.id
                                            ? '/edit.png'
                                            : '/edit_grey.png'
                                        }
                                        alt="Edit"
                                        style={{
                                          marginTop: '1px',
                                          width: '16px',
                                          height: '16px',
                                        }}
                                      />
                                    </Tooltip>
                                  </button>

                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      if (workspace.contentType === 1) {
                                        deleteWorkspace(workspace.id, workspace.name);
                                      } else {
                                        deleteContent(workspace);
                                      }
                                    }}
                                    data-testId={`${workspace.name}_delete`}
                                    style={{
                                      background: 'none',
                                      border: 'none',
                                    }}
                                  >
                                    <Tooltip
                                      title="Delete"
                                      slotProps={{
                                        tooltip: {
                                          sx: {
                                            fontSize: '12px',
                                          },
                                        },
                                      }}
                                    >
                                      <img
                                        src={
                                          hoveredRowId === workspace.id
                                            ? '/delete_red.png'
                                            : '/delete_grey.png'
                                        }
                                        alt="Delete"
                                        style={{
                                          marginTop: '1px',
                                          width: '17px',
                                          height: '17px',
                                        }}
                                      />
                                    </Tooltip>
                                  </button>

                                  {workspace.roleId < 5 ? (
                                    <button
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        if (workspace.contentType === 1) {
                                          openAccessModal(workspace.id, workspace.name);
                                        } else {
                                          openAccessModalforContent(workspace.id);
                                        }
                                      }}
                                      data-testId={`${workspace.name}_access`}
                                      style={{
                                        background: 'none',
                                        border: 'none',
                                      }}
                                    >
                                      <Tooltip
                                        title="Manage Access"
                                        slotProps={{
                                          tooltip: {
                                            sx: {
                                              fontSize: '12px',
                                            },
                                          },
                                        }}
                                      >
                                        <img
                                          src={
                                            hoveredRowId === workspace.id
                                              ? '/access.png'
                                              : '/access_grey.png'
                                          }
                                          alt="Access"
                                          style={{
                                            marginBottom: '-2.5px',
                                            width: '20px',
                                            height: '20px',
                                          }}
                                        />
                                      </Tooltip>
                                    </button>
                                  ) : (
                                    workspace.roleId !== 8 && (
                                      <button
                                        style={{
                                          background: 'none',
                                          border: 'none',
                                          cursor: 'not-allowed',
                                        }}
                                      >
                                        <Tooltip
                                          title="Manage Access"
                                          slotProps={{
                                            tooltip: {
                                              sx: {
                                                fontSize: '12px',
                                              },
                                            },
                                          }}
                                        >
                                          <img
                                            src={'/access_grey.png'}
                                            alt="Access"
                                            style={{
                                              marginBottom: '-2.5px',
                                              width: '20px',
                                              height: '20px',
                                              pointerEvents: 'none',
                                            }}
                                          />
                                        </Tooltip>
                                      </button>
                                    )
                                  )}
                                </>
                              ) : (
                                <>
                                  <button
                                    style={{
                                      background: 'none',
                                      border: 'none',
                                      cursor: 'not-allowed',
                                    }}
                                  >
                                    <Tooltip
                                      title="Rename"
                                      slotProps={{
                                        tooltip: {
                                          sx: {
                                            fontSize: '12px',
                                          },
                                        },
                                      }}
                                    >
                                      <img
                                        src={'/edit_grey.png'}
                                        alt="Edit"
                                        style={{
                                          marginTop: '1px',
                                          width: '16px',
                                          height: '16px',
                                          pointerEvents: 'none',
                                        }}
                                      />
                                    </Tooltip>
                                  </button>

                                  <button
                                    style={{
                                      background: 'none',
                                      border: 'none',
                                      cursor: 'not-allowed',
                                    }}
                                  >
                                    <Tooltip
                                      title="Delete"
                                      slotProps={{
                                        tooltip: {
                                          sx: {
                                            fontSize: '12px',
                                          },
                                        },
                                      }}
                                    >
                                      <img
                                        src={'/delete_grey.png'}
                                        alt="Delete"
                                        style={{
                                          marginTop: '1px',
                                          width: '17px',
                                          height: '17px',
                                          pointerEvents: 'none',
                                        }}
                                      />
                                    </Tooltip>
                                  </button>

                                  {workspace.roleId !== 8 && (
                                    <button
                                      style={{
                                        background: 'none',
                                        border: 'none',
                                        cursor: 'not-allowed',
                                      }}
                                    >
                                      <Tooltip
                                        title="Manage Access"
                                        slotProps={{
                                          tooltip: {
                                            sx: {
                                              fontSize: '12px',
                                            },
                                          },
                                        }}
                                      >
                                        <img
                                          src={'/access_grey.png'}
                                          alt="Access"
                                          style={{
                                            marginBottom: '-2.5px',
                                            width: '20px',
                                            height: '20px',
                                            pointerEvents: 'none',
                                          }}
                                        />
                                      </Tooltip>
                                    </button>
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                        )}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <div className="no-user-info">
                    <p
                      className="loading-default-text"
                      style={{
                        fontSize: fontSize.medium,
                        color: palette.primary.contrastText,
                      }}
                    >
                      No content found.
                    </p>
                  </div>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
        <PopUpSpinner show={dependencyLoading} />
        <Dialog open={showDeleteConfirmation} onClose={cancelDelete}>
          <div className="workspace-remove-modal" style={{ height: 'auto' }}>
            <div className="workspace-remove-modalContent-close" style={{ visibility: 'hidden' }}>
              <Tooltip
                title="Close"
                slotProps={{
                  tooltip: {
                    sx: {
                      fontSize: '12px',
                    },
                  },
                }}
              >
                <CloseIcon
                  onClick={cancelDelete}
                  sx={{
                    fontSize: 'large',
                    color: '#545454',
                    cursor: 'pointer',
                    '&:hover': {
                      color: 'red',
                    },
                  }}
                />
              </Tooltip>
            </div>

            <div className="workspace-remove-modalContent-p">
              <p
                style={{
                  fontSize: fontSize.medium,
                  color: palette.primary.contrastText,
                }}
              >
                Are you sure you want to delete the workspace {workspaceName}?
              </p>
            </div>

            <div className="workspace-modal-buttons">
              <button
                onClick={cancelDelete}
                className="workspace-modal-cancel"
                style={{ fontSize: fontSize.medium }}
              >
                Cancel
              </button>
              <button
                onClick={handleDeleteWorkspace}
                className="workspace-modal-confirm"
                style={{ fontSize: fontSize.medium }}
              >
                Confirm
              </button>
            </div>
          </div>
        </Dialog>

        {showContentDeleteConfirmation && (
          <Dialog open={showContentDeleteConfirmation} onClose={cancelDelete}>
            <div className="workspace-remove-modal" style={{ height: 'auto' }}>
              <div className="workspace-remove-modalContent-close" style={{ visibility: 'hidden' }}>
                <Tooltip
                  title="Close"
                  slotProps={{
                    tooltip: {
                      sx: {
                        fontSize: '12px',
                      },
                    },
                  }}
                >
                  <CloseIcon
                    onClick={cancelDelete}
                    sx={{
                      fontSize: 'large',
                      color: '#545454',
                      cursor: 'pointer',
                      '&:hover': {
                        color: 'red',
                      },
                    }}
                  />
                </Tooltip>
              </div>

              <div className="workspace-remove-modalContent-p">
                <p
                  style={{
                    fontSize: fontSize.medium,
                    color: palette.primary.contrastText,
                  }}
                >
                  Are you sure you want to delete the{' '}
                  {getContentTypeName(
                    selectedContent!.contentType,
                    (selectedContent as any).resourceType,
                  )}{' '}
                  {selectedContent!.name}?
                </p>
              </div>

              <div className="workspace-modal-buttons">
                <button
                  onClick={cancelDelete}
                  className="workspace-modal-cancel"
                  style={{ fontSize: fontSize.medium }}
                >
                  Cancel
                </button>
                <button
                  onClick={handleDeleteContent}
                  className="workspace-modal-confirm"
                  style={{ fontSize: fontSize.medium }}
                >
                  Confirm
                </button>
              </div>
            </div>
          </Dialog>
        )}

        {/* Edit Workspace Modal  */}
        {isEditModalOpen && (
          <div className={styles.subworkspaceModal}>
            <div className={styles.subworkspaceModalContent}>
              <h3>Rename</h3>
              <div
                className={styles.subworkspaceModalContentInput}
                style={{ height: errorMessage ? '30px' : '40px' }}
              >
                <input
                  type="text"
                  value={workspaceName}
                  onChange={(e) => {
                    const value = e.target.value;
                    setWorkspaceName(value);

                    if (value.length > 40) {
                      setErrorMessage('Workspace name cannot exceed 40 characters.');
                    } else {
                      setErrorMessage('');
                    }
                  }}
                  style={{
                    border: workspaceName.length > 40 ? '1px solid red' : '',
                  }}
                  placeholder="Workspace Name"
                />
              </div>
              <div className={styles.errorMessageContainer}>
                {errorMessage && (
                  <p style={{ color: 'red', fontSize: fontSize.small, marginTop: '18px' }}>
                    {errorMessage}
                  </p>
                )}
              </div>
              <div className={styles.subworkspaceModalButtons}>
                <button
                  className={styles.subworkspaceModalCancel}
                  onClick={() => {
                    setIsEditModalOpen(false);
                    setErrorMessage('');
                  }}
                >
                  Cancel
                </button>
                <button className={styles.workspaceSaveButton} onClick={handleEditContent}>
                  Rename
                </button>
              </div>
            </div>
          </div>
        )}

        {isModalOpen && (
          <div className={styles.subworkspaceModal}>
            <div className={styles.subworkspaceModalContent}>
              <h3>Name your {modalType}</h3>
              <div className={styles.subworkspaceModalContentInput}>
                <input
                  type="text"
                  autoFocus
                  required
                  // value={workspaceName}
                  onChange={(e) => {
                    const value = e.target.value;
                    setWorkspaceName(value);

                    if (value.length > 40) {
                      setErrorMessage('Workspace name cannot exceed 40 characters.');
                    } else {
                      setErrorMessage('');
                    }
                  }}
                  placeholder={`Enter ${modalType} name`}
                  // className={styles.workspaceInput}
                  style={{
                    border: errorMessage ? '1px solid red' : '',
                  }}
                />
              </div>
              {/* Error message section */}
              {errorMessage && (
                <div
                  className={styles.errorMessage}
                  style={{
                    fontSize: fontSize.small,
                    color: 'red',
                  }}
                >
                  {errorMessage}
                </div>
              )}
              <div className={styles.subworkspaceModalButtons}>
                <button
                  className={styles.subworkspaceModalCancel}
                  onClick={() => {
                    setIsModalOpen(false);
                    setErrorMessage('');
                  }}
                >
                  Cancel
                </button>
                <button className={styles.workspaceSaveButton} onClick={handleCreateWorkspace}>
                  Create
                </button>
              </div>
            </div>
          </div>
        )}

        <ScheduleRefresh
          open={scheduledRefresh}
          setOpen={setScheduledRefresh}
          selectedDataset={selectedDataset}
        />

        <DatabaseConnectionDialogComponents
          onCloseAlert={() => {
            setOpenAlert(false);
            setTestMessage('');
          }}
          severity={severity}
          testMessage={testMessage}
          openAlert={openAlert}
        />
        {dsInfo && (
          <Dialog
            open={!!dsInfo}
            onClose={() => setdsInfo(null)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth
          >
            <DialogTitle
              id="alert-dialog-title"
              sx={{
                fontSize: fontSize.large,
                fontWeight: '600',
              }}
            >
              Refresh Info
            </DialogTitle>
            <DialogContent
              sx={{
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <DialogContentText id="alert-dialog-description">
                <b>{dsInfo.name}</b> last refreshed{' '}
                <b>
                  {dsInfo.refreshed
                    ? formatDistanceToNow(parseISO(dsInfo.refreshed), {
                        addSuffix: true,
                      })
                    : 'No date available'}
                </b>
              </DialogContentText>
            </DialogContent>
          </Dialog>
        )}
        <PopUpSpinner
          show={_loading}
          paperProps={{
            sx: {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            },
          }}
          text="Refreshing dataset"
        />
        {alert && (
          <NotificationDialog
            onCloseAlert={() => setAlert(null)}
            severity={alert.severity}
            testMessage={alert.message}
            openAlert={!!alert}
          />
        )}

        <Dialog
          open={refreshed}
          onClose={() => {
            refetch();
            setRefreshed(false);
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            id="alert-dialog-title"
            sx={{
              fontWeight: 'bold',
            }}
          >
            {'Dataset refresh'}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Dataset refreshed <b>successfully.</b>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                refetch();
                setRefreshed(false);
              }}
              autoFocus
            >
              Ok
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </React.Fragment>
  );
};

export default SubWorkspace;
